import React, {memo} from 'react'
import {Breadcrumb, Button, Container, Divider, Dropdown, Form, Grid, Icon, Segment} from 'semantic-ui-react'
import {withChildPathProps, withErrorHandling, withPropsPresent, withServicesData, withMeData} from '../../hoc'
import {getFirstService, getPublishedOrFirstVersion} from '../../util'
import {TopNav} from '../shared'

const _Directory = (
  {
    services = [],
    service,
    versionId,
    navigate,
    display,
    me,
    basePath = '/c/directory',
    children
  }
) => {

  const onSelectService = (e, d) => {
    e.preventDefault()
    navigate(`${basePath}/services/${d.value}/versions/${versionId}/display/${display}`)
  }

  const onSelectVersion = (e, d) => {
    e.preventDefault()
    navigate(`${basePath}/services/${service.id}/versions/${d.value}/display/${display}`)
  }

  const onSelectDisplay = (e, d) => {
    e.preventDefault()
    navigate(`${basePath}/services/${service.id}/versions/${versionId}/display/${d.value}`)
  }

  const onManage = () => {
    navigate(`/c/services/${service.id}/versions/${versionId}/environments`)
  }

  const serviceOptions = services.map((s) => {
    return {key: s.id, text: s.name, value: s.id}
  })
  const versions = service.versions
  const versionOptions = versions.map((v) => {
    return {key: v.id, text: `${v.name}${v.published ? ' *' : ''}`, value: v.id}
  })
  const displayOptions = [
    {key: 'oas', text: 'OAS (swagger)', value: 'oas'},
    {key: 'api', text: 'API Docs (redoc)', value: 'api'}
  ]

  return (
    <>
      <Container style={{marginTop: '5em', marginBottom: '2em'}}>
        <TopNav navigate={navigate} me={me}/>
        <Grid>
          <Grid.Row coloumns='16'>
            <Grid.Column width='16'>
              <Breadcrumb>
                <Breadcrumb.Section link onClick={() => navigate('/')}>Home</Breadcrumb.Section>
                <Breadcrumb.Divider/>
                <Breadcrumb.Section active>Directory</Breadcrumb.Section>
              </Breadcrumb>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns='16'>
            <Grid.Column width='16'>
              <Segment>
                <Form style={{float: 'left'}}>
                  <Form.Group>
                    <Form.Field inline>
                      <label>Service</label>
                      <Dropdown search selection
                                options={serviceOptions}
                                value={service.id}
                                data-testid='services-dropdown'
                                onChange={onSelectService}/>
                    </Form.Field>
                    <Form.Field inline>
                      <label>Version</label>
                      <Dropdown search selection
                                options={versionOptions}
                                value={versionId}
                                data-testid='versions-dropdown'
                                onChange={onSelectVersion}/>
                    </Form.Field>
                    <Form.Field inline>
                      <label>Display As</label>
                      <Dropdown search selection
                                options={displayOptions}
                                value={display}
                                data-testid='display-as-dropdown'
                                onChange={onSelectDisplay}/>
                    </Form.Field>
                  </Form.Group>
                </Form>

                <Button basic primary onClick={onManage} style={{float: 'right'}} data-testid='manage-button'>
                  Manage
                  <Icon name='right arrow'/>
                </Button>
                <div style={{clear: 'right'}}/>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
      <Divider/>
      <Container fluid>
        {children}
      </Container>
    </>
  )
}

let Directory = (props) => {
  if (!props.services.length) {
    props.navigate('/c/services')
    return null
  }

  const {serviceId, versionId, services} = props
  const service = services.find(s => s.id === serviceId) || getFirstService(services)
  const version = service ? service.versions.find(v => v.id === versionId) || getPublishedOrFirstVersion(service) : undefined

  if (service && version) {
    if (service.id !== serviceId || version.id !== versionId) {
      props.navigate(`/c/directory/services/${service.id}/versions/${version.id}/display/oas`)
      return null
    }
  } else {
    props.navigate('/c/services')
    return null
  }

  props = {...props, service}

  return (<_Directory {...props}/>)
}

Directory = withPropsPresent(Directory, ['services', 'me'])
Directory = withChildPathProps(Directory)
Directory = withMeData(Directory, 'Loading profile...', false)
Directory = withServicesData(Directory, 'Loading services...', false)
Directory = withErrorHandling(Directory)
Directory = memo(Directory)

export {_Directory, Directory}

export default Directory